import React, { Component } from 'react';
import type { MemoizedFn } from 'memoize-one';
import memoize from 'memoize-one';

import { getLegacyMessageQueue } from '@confluence/legacy-message-queue';

import { CreateDialogContext } from './CreateDialogContext.tsx';
import { getDefaultChangeableValues } from './defaults.ts';
import type {
	OpenBlueprintWizardParams,
	OpenTemplateVariablesParams,
	ChangeableValues,
	CreateDialogContextType,
} from './create-dialog-context-types.ts';

export class CreateDialogContextProvider extends Component<
	React.PropsWithChildren<{}>,
	ChangeableValues
> {
	constructor(props: any) {
		super(props);

		this.state = getDefaultChangeableValues;
	}

	componentDidMount(): void {
		void getLegacyMessageQueue().then((legacyMessageQueue) => {
			legacyMessageQueue.push({
				type: 'ATLASSIAN_CONFLUENCE_VARIABLEINPUT_REGISTER_CALLBACK',
				payload: this.openTemplateVariables,
			});
		});
	}

	openTemplateVariables = ({
		templateId,
		parentPageId,
		spaceKey,
		title,
		contentId,
		onContentUpdated,
		onError,
		beforeUpdateRequest,
		forceTemplatePanelOpen,
		openContentInNewTab,
	}: OpenTemplateVariablesParams): void => {
		this.setState({
			templateId,
			parentPageId,
			spaceKey,
			title,
			contentId,
			onContentUpdated,
			onError,
			showTemplateVariableInputDrawer: true,
			beforeUpdateRequest,
			forceTemplatePanelOpen,
			openContentInNewTab,
		});
	};

	openBlueprintWizard = ({
		blueprint,
		parentPageId,
		spaceKey,
		templateOriginSpaceKey,
		title,
		contentId,
		onContentUpdated,
		onError,
		beforeUpdateRequest,
	}: OpenBlueprintWizardParams): void => {
		this.setState({
			contentId,
			blueprint,
			parentPageId,
			spaceKey,
			templateOriginSpaceKey,
			onContentUpdated,
			onError,
			showBlueprintVariableWizard: true,
			title: title || '',
			beforeUpdateRequest,
		});
	};

	onClose = (): void => {
		this.setState(getDefaultChangeableValues);
	};

	getProviderValue: MemoizedFn<(state: ChangeableValues) => CreateDialogContextType> = memoize(
		(state: ChangeableValues): CreateDialogContextType => ({
			...state,
			openTemplateVariables: this.openTemplateVariables,
			openBlueprintWizard: this.openBlueprintWizard,
			onClose: this.onClose,
		}),
	);

	render(): React.JSX.Element {
		return (
			<CreateDialogContext.Provider value={this.getProviderValue(this.state)}>
				{this.props.children}
			</CreateDialogContext.Provider>
		);
	}
}
